import {
  LOAN_APPLICATION_FETCH_SUCCESS,
  UPDATE_INCOME_SUCCESS,
  UPDATE_FINANCIALS_SUCCESS,
  UPDATE_INCOME_FAILURE,
  LOAN_APPLICATION_USER_GOBACK_SUCCESS,
  LOAN_APPLICATION_USER_GOTO_SUCCESS,
  INCOME_SOURCE_CHANGED,
  BUILD_INCOME,
  INCOME_CHANGED,
} from '../../actions/types'

const START_STATE = [{}];

export const getMainIncome = (state) => {
  return state[0];
}

function getIncomeIndexById(state, id, currentApplicant) {
  const index = state.findIndex(income => income.key === id)

  if (index !== -1) {
    return index
  }

  return 0
}

const mapIncomes = (incomes) => {
  if (!Array.isArray(incomes) && Object.keys(incomes).length) {
    incomes = Object.values(incomes)

    incomes.map((income) => {
      if (income.additionalPaygIncomes) {
        const details = Object.values(income.additionalPaygIncomes).reduce((acc, detail) => {
          acc[detail.paygIncomeType] = detail
          acc[detail.paygIncomeType]['active'] = true

          return acc
        }, {})

        income.additionalPaygIncomes = details
      }
    })

    return incomes
  }

  return [{}]
}

const income = (state=START_STATE, {type, payload}) => {
  let isPrimary = true;
  let primary, secondary = [{}];
  let flowState = 'income'
  if (payload && payload.income) {
    flowState = payload.loanApplicationUser.flowState
    primary = payload.income;
    secondary = payload.secondaryIncome
  }

  if (payload && payload.applicationFlow && payload.applicationFlow.income) {
    flowState = payload.applicationFlow.loanApplicationUser.flowState
    primary = payload.applicationFlow.income;
    secondary = payload.applicationFlow.secondaryIncome
  }
  isPrimary = flowState === 'income'
  switch(type) {
    case UPDATE_INCOME_SUCCESS:
    case LOAN_APPLICATION_FETCH_SUCCESS:
      window.scrollTo({top: 0})
      if (primary && !Array.isArray(primary) && Object.keys(primary).length > 0) {
        primary = mapIncomes(primary);
        if (flowState === 'secondary_income') {
          secondary = mapIncomes(secondary);
          return secondary;
        }

        return primary;
      }

      return state;
    case UPDATE_FINANCIALS_SUCCESS:
    case UPDATE_INCOME_FAILURE:
    case LOAN_APPLICATION_USER_GOTO_SUCCESS:
    case LOAN_APPLICATION_USER_GOBACK_SUCCESS:
      let primaryIncome = payload.income ? Object.values(payload.income) : [{}];
      let secondaryIncome = payload.secondaryIncome ? Object.values(payload.secondaryIncome) : [{}];
      return isPrimary ? primaryIncome : secondaryIncome

    case INCOME_SOURCE_CHANGED:
      return [
        {
          ...getMainIncome(state),
          amount: null,
          amountPreviousYear: null,
          frequency: 'yearly',
          frequencyPreviousYear: 'yearly',
        },
        ...state.slice(1)
      ]


    case BUILD_INCOME:
      return [
        ...state,
        { ...payload.data, errors: {} }
      ]


    case INCOME_CHANGED:
      const { key, currentApplicant } = payload

      if (currentApplicant) {
        const incomeIndex = getIncomeIndexById(state, key, currentApplicant)
        const changedIncome = state.find(income => income.key === key)

        // Remove income from store if it was removed from the user but wasn't yet added to the DB
        if (payload._destroy === 1 && !changedIncome.id) {
+          state.splice(incomeIndex)
        } else {
          state[incomeIndex] = {
            ...state[incomeIndex],
            ...payload
          }
        }

        return state
      }

    default:
      return state
  }
}

export default income
